import { ROUTE_KEYS } from './constants';
import { getCompletePathFromRouteKey } from './navigationUtils';

export function useDefaultLandingPage() {
  return getCompletePathFromRouteKey(ROUTE_KEYS.HOUSEHOLDS_LIST, {});
}
